export const plansConstants = {
  elitePlusTitle: 'Elite Plus',
};
